import * as React from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import GlobalContext from "./GlobalContext";

import CategoriesList from "./CategoriesList/CategoriesList";
import ResultsByCategory from "./ResultsByCategory";
import ResultsBySearch from "./ResultsbySearch";

export default function AppRoutes() {
  let location = useLocation();
  let navigate = useNavigate();
  const global = React.useContext(GlobalContext);

  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const catParam = queryParams.get('cat');
    const queryParam = queryParams.get('query');

    if (location.pathname === '/search' && catParam !== null && queryParam !== null && !catParam && !queryParam) {
      navigate('/');
    }
  }, [location, navigate]);

  if (!global.state.initialized) return false;

  return (
    <Routes location={location}>
      <Route path='/search?cat=&query=' element={<CategoriesList />} />
      <Route path='/search' element={<ResultsBySearch />} />
      <Route path='/:categorySlug' element={<ResultsByCategory />} />
      <Route path='/' element={<CategoriesList />} />
    </Routes>
  );
}